import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.stemExtensionsData || initialState;

export const selectStemExtensionsData = createSelector(
  [selectSlice],
  state => state.data,
);

export const selectStemExtensionIsLoading = createSelector(
  [selectSlice],
  state => state.isLoading,
);
